<template>
  <th class="subsearch-toggle-area-bar" id="detailedsearch_tit_region">
    <p class="detailedsearch_tit">
      開催形式
    </p>

    <ul class="detailedsearch_list">
      <li>
        <label for="is_online">
          <input v-model="innerIsOnline" id="is_online" type="checkbox" true-value="1" false-value="" name="is_online"><span>オンライン</span>
        </label>
      </li>
      <li>
        <label for="is_facing">
          <input v-model="innerIsFacing" id="is_facing" type="checkbox" true-value="1" false-value="" name="is_facing"><span>対面</span>
        </label>
      </li>
    </ul>
  </th>
</template>

<script setup>
import { computed, inject } from 'vue'

const isOnlineStore = inject('isOnlineStore')
const isFacingStore = inject('isFacingStore')

const innerIsOnline = computed({
  get: () => isOnlineStore.isOnline.value,
  set: (value) => isOnlineStore.set(value)
})
const innerIsFacing = computed({
  get: () => isFacingStore.isFacing.value,
  set: (value) => isFacingStore.set(value)
})
</script>
